import { Pipe, PipeTransform } from '@angular/core';
import { ProductDetailViewModel, RelatedProperties, StringRelatedPropertyValue } from '@models/api-search.models';

@Pipe({
    name: 'getSelectedVariant',
    standalone: true
})
export class GetSelectedVariantPipe implements PipeTransform {
    /**
     * Get the property value from the related property key
     * @param value - The product detail view model
     * @param key - The related property key
     * @returns The property value from the related property key in string format
     */
    transform(value: ProductDetailViewModel | null, key: keyof RelatedProperties): string {
        if (!value || !value.relatedProperties) {
            return '';
        }

        if (key in value) {
            const relatedPropertyValue = value[key as keyof ProductDetailViewModel] as StringRelatedPropertyValue;
            const relatedProperties: StringRelatedPropertyValue[] = value.relatedProperties[
                key
            ] as StringRelatedPropertyValue[];

            return relatedProperties.reduce((acc, p) => {
                // special case for primaryColor
                if (key === 'primaryColor') {
                    acc = `${value.primaryColor?.text}`;
                    return acc;
                }

                // Compare the ProductDetailViewModel property with the relatedProperties value
                if (p.value === relatedPropertyValue.key) {
                    acc = `${p.key}`;
                    return acc;
                }

                // Used to get the unit of the related property value
                if (p.value === relatedPropertyValue) {
                    acc = `${p.value} ${p.unit?.text}`;
                    return acc;
                }

                return acc;
            }, '');
        }
        return '';
    }
}
